export default __webpack_public_path__ + "static/media/iconoDrawer.15237984.svg";